'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useCookieConsent } from '@/context/cookieConsentContext';
import { isGoogleAnalyticsReady, processGAQueue } from '@/lib/googleAnalytics';
export default function GoogleAnalyticsProvider() {
  const $ = _c(4);
  const {
    consentGiven,
    isMounted
  } = useCookieConsent();
  const timeoutRef = useRef(null);
  const attemptsRef = useRef(0);
  let t0;
  let t1;
  if ($[0] !== consentGiven || $[1] !== isMounted) {
    t0 = () => {
      const cleanup = () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = null;
        }
        attemptsRef.current = 0;
      };
      if (!isMounted || typeof window === "undefined") {
        cleanup();
        return;
      }
      if (consentGiven === "accepted") {
        const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
        if (!measurementId || process.env.NODE_ENV !== "production") {
          cleanup();
          return;
        }
        if (isGoogleAnalyticsReady()) {
          processGAQueue();
          cleanup();
        } else {
          const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`);
          if (!existingScript) {
            const script = document.createElement("script");
            script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
            script.async = true;
            document.head.appendChild(script);
            const initScript = document.createElement("script");
            initScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${measurementId}', {
              page_path: window.location.pathname,
            });
          `;
            document.head.appendChild(initScript);
          }
          const monitorGoogleAnalytics = () => {
            if (isGoogleAnalyticsReady()) {
              processGAQueue();
              cleanup();
            } else {
              attemptsRef.current = attemptsRef.current + 1;
              if (attemptsRef.current >= 50) {
                cleanup();
                return;
              }
              timeoutRef.current = setTimeout(monitorGoogleAnalytics, 100);
            }
          };
          monitorGoogleAnalytics();
        }
      } else {
        cleanup();
      }
      return cleanup;
    };
    t1 = [consentGiven, isMounted];
    $[0] = consentGiven;
    $[1] = isMounted;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}